(() => {
  const sections = document.querySelectorAll('.support-infographic');

  if (!sections.length) {
    return;
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealSection = (section) => {
    section.classList.add('is-revealed');
  };

  if (!('IntersectionObserver' in window) || prefersReducedMotion) {
    sections.forEach((section) => {
      revealSection(section);
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        revealSection(entry.target);
        currentObserver.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.16
    }
  );

  sections.forEach((section) => {
    if (section.dataset.enableAnimation !== 'true') {
      revealSection(section);
      return;
    }

    section.classList.add('is-observing');
    observer.observe(section);
  });

  // Slight 2D rotation on scroll for shoe image (triggers at 20% visible, both directions)
  const mediaContainers = document.querySelectorAll('.support-infographic__media[data-image-tilt="true"]');
  if (!mediaContainers.length || prefersReducedMotion) {
    return;
  }

  const ROTATE_VISIBILITY_MIN = 0.15;
  const ROTATE_MAX = 4;

  let ticking = false;

  const updateRotation = () => {
    const vh = window.innerHeight;

    mediaContainers.forEach((media) => {
      const inner = media.querySelector('.support-infographic__media-inner');
      if (!inner) return;

      const rect = media.getBoundingClientRect();
      const visibleTop = Math.max(0, rect.top);
      const visibleBottom = Math.min(vh, rect.bottom);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);
      const visibleRatio = rect.height > 0 ? visibleHeight / rect.height : 0;

      if (visibleRatio < ROTATE_VISIBILITY_MIN) {
        inner.style.transform = 'rotate(0deg)';
        media.style.removeProperty('--shadow-offset');
        return;
      }

      const centerY = rect.top + rect.height / 2;
      const position = (vh - centerY) / vh;
      const rotate = Math.max(-ROTATE_MAX, Math.min(ROTATE_MAX, (position - 0.5) * ROTATE_MAX * 2));

      inner.style.transform = `rotate(${rotate}deg)`;
      media.style.setProperty('--shadow-offset', `${rotate * 1.5}px`);
    });

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(updateRotation);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateRotation);
  updateRotation();
})();
